import Backbone from '@polleverywhere/backbone'
import { html, render } from 'lit-html'
import { ifDefined } from 'lit-html/directives/if-defined'

import '@polleverywhere/pe-text-field'

export default class BasicField extends Backbone.View {
  get className () {
    return 'component-auth__basic-field'
  }

  get $input () {
    return this.$('input')
  }

  get field () {
    return this.$('pe-text-field')[0]
  }

  get name () {
    return this.options.name
  }

  initialize (options = {}) {
    this.options = options
  }

  toggleError (error) {
    this.field.error = error
  }

  validate () {
    return this.field.validate()
  }

  render () {
    render(html`
    <pe-text-field
      ?required=${!!this.options.required}
      ?readonly=${!!this.options.readonly}
      spellcheck=${ifDefined(this.options.spellcheck)}
      autocapitalize=${this.options.autocapitalize || 'off'}
      autocomplete=${this.options.autocomplete || 'off'}
      autocorrect=${this.options.autocorrect || 'off'}
      minLength=${ifDefined(this.options.minLength)}
      name=${this.name}
      pattern=${ifDefined(this.options.pattern)}
      placeholder=${this.options.placeholder}
      type=${this.options.type || 'text'}
      value=${ifDefined(this.options.value)}
      @invalid=${(...args) => this.trigger('error', ...args)}
      @change=${() => this.validate()}
    ></pe-text-field>
    `, this.el)

    return this
  }
}
